import { render, staticRenderFns } from "./NewPriceList.vue?vue&type=template&id=094f5c5f&scoped=true"
import script from "./NewPriceList.vue?vue&type=script&lang=js"
export * from "./NewPriceList.vue?vue&type=script&lang=js"
import style0 from "./NewPriceList.vue?vue&type=style&index=0&id=094f5c5f&prod&lang=scss&scoped=true"
import style1 from "./NewPriceList.vue?vue&type=style&index=1&id=094f5c5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f5c5f",
  null
  
)

export default component.exports